import { Bag5 } from '@solar-icons/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDropcart } from '~/context/DropcartContext';
import { useOrder } from '~/context/OrderContext';

const DropCart: React.FC = () => {
  const { t } = useTranslation();
  const { order } = useOrder();
  const { toggleDropcart } = useDropcart();
  const cartProductsCount = order?.items?.reduce((sum, item) => sum + (item.quantity || 0), 0) || 0;

  return (
    <button
      type="button"
      onClick={toggleDropcart}
      className="btn btn-primary p-2 d-inline-flex align-items-center justify-content-center cart-toggle position-relative"
      aria-label={t('go_to_cart')}
    >
      <Bag5 size={24} color="#fff" />
      {cartProductsCount > 0 && <span className="position-absolute cart-count">{cartProductsCount}</span>}
    </button>
  );
};

export default DropCart;
